import fetch from 'isomorphic-fetch';
import BaseApi from '../../../../shared/javascripts/api/BaseApi'

class MonitoringApi extends BaseApi {
  static statuses(siteName) {
    return fetch(this.buildRequest(`/v1/admin/statuses.json?site_name=${siteName}`))
  }
}

export default MonitoringApi



// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/api/MonitoringApi.js